import i18n from "../i18n";
import $http from "../axios";

const state = {
  locale: localStorage.getItem("locale") || navigator.language.replace("-", "_")
};

const getters = {
  locale(state) {
    return state.locale;
  }
};

const actions = {
  setLocale({ commit, getters }, l) {
    const sessionToken = getters.sessionToken;

    if (!sessionToken) {
      // When there isn't a session token, set locale only on local storage
      commit("SET_LOCALE", l);
      console.warn("Cannot set locale because the user is not authenticated");
      return Promise.resolve();
    }

    commit("SET_LOCALE", l);
    return new Promise((resolve, reject) => {
      $http
        .post("save-account-locale", { locale: l })
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_LOCALE", l);
          } else if (res.data.result !== "ok") {
            console.error("Error saving locale to account");
          }
          resolve(res);
        })
        .catch(e => {
          console.error("Error saving locale", e);
          reject(e);
        });
    });
  }
};

const mutations = {
  SET_LOCALE(state, l) {
    i18n.locale = l;
    state.locale = l;
    localStorage.setItem("locale", l);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
